export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13502.42f197a0.jpg";